module.exports = __webpack_public_path__ + "media/images/childcare/cover-mobile@3x-e7d59523e75706f28fdcc52a0d163f1f.jpg";